import { render } from "./LeftView.vue?vue&type=template&id=050c00df"
import script from "./LeftView.vue?vue&type=script&lang=js"
export * from "./LeftView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__